<template>
  <div class="item-box">
    <span class="title" v-text="itemName"></span>：
    <span class="content" v-html="itemContent"></span>
  </div>
</template>

<script>
  export default{
    name: 'item-user-profile',
    props: {
      itemName: {
        type: String,
        default: ''
      },
      itemContent: {
        type: String,
        default: ''
      }
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';

  .item-box {
    height: px2rem(45);
    line-height: px2rem(45);
    display: flex;
  }

  span {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// ItemUserProfile.vue?df849c24